import { local } from "services/storage/general";
import doRequest from "../helpers";

export const requestLogin = async (form) => {
    const [result, err] = await doRequest(
        "/api/login/authenticateApp", "POST", {
            usuario: form.user,
            contrasena: form.password,
            sistema: "UTP",
            ip: "192.168.1.1"
        });
    if (err)
        return;
    const { data } = result;
    if (!data?.token)
        return false;
    const { token } = result.data;
    saveToken(token);
    return true;
}
export const saveToken = token => {
    local.set("token", token);
}
export const getToken = () => {
    return local.get("token");
}
export const isLogged = () => {
    return local.get("token") ? true : false;
}
export const clearAllStorage = () => {
    localStorage.clear();
    sessionStorage.clear();
}